import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Name = styled.h2(
  ({theme}) => css`
    margin: 0%;
    ${theme.typography.labelMediumBold};
    text-wrap: pretty;
    text-decoration: none;
    color: inherit;

    > svg {
      margin-left: 0.5ch;
      vertical-align: sub;
    }

    ${theme.respondTo(
      'lg',
      css`
        ${theme.typography.labelLargeBold};
      `
    )}
  `
);
